import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * A sugar function around useSearchParams, to allow you to destructure the return type without
 * checking for types
 */
export function useQuerystring(): { [k: string]: string } {
  const [search] = useSearchParams();
  return useMemo(() => Object.fromEntries(search.entries()), [search]);
}
